import React from "react";
import styled from "styled-components";
import {primaryRankingTagColour, primaryRankingTagTextColour} from "../../../../style/styleConsts";


const Container = styled.div`
   background-color: ${primaryRankingTagColour};
   border-radius: 3px;
   padding: 1px 4px;
   font-size: 80%;
   color: ${primaryRankingTagTextColour};
   vertical-align: 10%;
   margin-left: 10px;
`;

const PrimaryRanking = ({}) => {
    return <Container className="t-primary-ranking">
        PRIMARY RANKING
    </Container>;
};

export default PrimaryRanking;